/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useQuery } from "@tanstack/react-query";
import { getWebpagesBySlug } from "lib/webpagesApi";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import PageLayout from "templates/PageLayout";

export default function WebPages() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { pageSlug, eventId } = useParams();

  const handleWebPageContent = ({
    richText,
    htmlCode,
  }: {
    richText?: string;
    htmlCode?: string;
  }) => {
    if (!iframeRef.current) return;

    const iframe = iframeRef.current;

    let htmlContent = richText || htmlCode || "";

    const blob = new Blob([htmlContent], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    iframe.src = url;
  };

  const { data } = useQuery({
    queryKey: ["webPage", pageSlug, eventId],
    queryFn: () => getWebpagesBySlug(pageSlug || "", eventId),
    enabled: !!pageSlug,
  });

  useEffect(() => {
    if (data?.data?.page) {
      if (data.data.page.page_type === "rich_text") {
        handleWebPageContent({
          richText: data.data.page.rich_text_content,
        });
      } else {
        handleWebPageContent({
          htmlCode: data.data.page.custom_html,
        });
      }
    }
  }, [data]);

  return (
    <PageLayout
      title=""
      containerClassName="!p-0 !m-0 !block max-w-full min-h-screen [&>div]:!mb-0"
      showFooter={false}
    >
      <iframe
        ref={iframeRef}
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        className=" "
        title="Page"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation"
      />
    </PageLayout>
  );
}
